import { sendMessage } from "./channelMessageUtility";
import type { IWACHostEndDocumentSession } from "./messageTypes/Command";
import type { ICommandMessage } from "./messageTypes/Message";

export function generateId(): string {
  try {
    return crypto.randomUUID();
  } catch {
    const array = new Uint8Array(16);
    crypto.getRandomValues(array);
    return array.join("");
  }
}

// Sends message to SPO that OWLET is ending the session
// Hides an iframe for a set timeout and then removes it from the DOM
export function hideAndRemoveFrame(
  frame: HTMLIFrameElement,
  timeout: number
): void {
  const message: ICommandMessage = {
    type: "command",
    id: 0,
    data: {
      command: "host-end-document-session",
    } as IWACHostEndDocumentSession,
  };

  // TODO: create a more graceful way to end the session
  console.log(timeout); // logging timeout to avoid unused variable
  sendMessage(message);
  frame.remove();
}
